import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { hrEmployerApi } from "@/lib/api/hr";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Page, Panel } from "@/components/shell/page";

export default function EmployerSettingsPage() {
  const { data } = useQuery({
    queryKey: ["hr", "employer", "settings"],
    queryFn: () => hrEmployerApi.settings(),
  });
  const [form, setForm] = useState<any>({});
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  return (
    <Page title="Settings" description="How the organization records hours and treats missed tasks.">
      <Panel title="Working hours" className="max-w-2xl">
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1 sm:col-span-2">
            <Label htmlFor="frequency">Logging frequency</Label>
            <select
              id="frequency"
              className="field-control"
              value={form.hours_frequency || "daily"}
              onChange={(e) => setForm({ ...form, hours_frequency: e.target.value })}
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>
          <div className="space-y-1">
            <Label htmlFor="expected">Expected hours / day</Label>
            <Input
              id="expected"
              value={form.expected_hours_day ?? 8}
              onChange={(e) => setForm({ ...form, expected_hours_day: Number(e.target.value) })}
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="missed">Missed task policy</Label>
            <select
              id="missed"
              className="field-control"
              value={form.missed_task_policy || "missed"}
              onChange={(e) => setForm({ ...form, missed_task_policy: e.target.value })}
            >
              <option value="missed">Mark missed</option>
              <option value="pending">Keep pending</option>
              <option value="carry_forward">Carry forward</option>
            </select>
          </div>
          <div className="sm:col-span-2">
            <Button
              onClick={async () => {
                await hrEmployerApi.saveSettings(form);
                setSaved(true);
              }}
            >
              Save settings
            </Button>
            {saved && <p className="mt-2 text-sm text-emerald-800" role="status">Settings saved.</p>}
          </div>
        </div>
      </Panel>
    </Page>
  );
}
